import Channel from '@/shared/classes/channels/channel'
import { useEffect, useState } from 'react'

import { useSearchBy } from '@/shared/hooks/useSearchBy'

const useFilteredBySearchChannels = (
    channels: Channel[],
    searchValue: string
) => {
    const [finallyFiltered, setFinallyFiltered] = useState(channels)
    const { filteredArray } = useSearchBy(channels, searchValue)

    useEffect(() => {
        let arrayToFilterFrom = []
        arrayToFilterFrom = searchValue.length ? filteredArray : channels
        setFinallyFiltered(arrayToFilterFrom)
    }, [filteredArray, channels])

    return { finallyFiltered }
}

export default useFilteredBySearchChannels
